// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Days_Top__ICOJw {
  background-color: #1a959c;
  background-color: #146871;
  background-color: #208286;
  background-color: #1a959c;
  background-color: #1ea7ae;
  background-color: #0095a3;
  background-color: #39606e;
  color: #fff;
  font-weight: bold;
}

.Days_Titledetail__U4r0I {
  color: #000;
  color: #fff;
  font-size: .65rem;
}

.Days_Bottom__7Rwr9 {
  background-color: #000;
  background-color: #353839;
  background-color: #010b13;
  color: #fff;
}

.Days_Bottom__7Rwr9:hover {
  background-color: #0095a3;
  color: #fff;
}

.Days_Bottom__7Rwr9:hover .Days_Titledetail__U4r0I {
  color: #fff;
}

.Days_BreakTitle__Fz8aP {
  border-top: 10px solid #e8f0f1;
}

.Days_Icon__bddJl i {
  color:#fff;
}

.Days_Icon__bddJl i:hover {
  color:#000;
}

.Days_PostDropdown__Pktp7 .Days_DropdownItem__baHX7 i {
  color: #666;
}

.Days_SceneLoc__glnaq {
  min-height: 130px;
}

.Days_BottomSB__-JABI {
  border-top: 1px solid #00d1ff;
}

.Days_BottomS__bSeNJ {
  font-style: italic;
  color: #fff;
  /* color: #0095a3;
  color: #00d1ff; */
}

.Days_Bottom__7Rwr9 span:hover {
  background-color: #1a959c;
  color: #fff;
}

.Days_SearchBar__57zkn input {
    border-radius: 20px;
    color: #242a3d;
    padding-left: 40px;
    margin-bottom: 16px;
  }
  
  .Days_SearchIcon__E6On9 {
    position: absolute;
    font-size: 1.2rem;
    padding: 9px;
    padding-left: 15px;
  }
  
  .Days_SearchIcon__E6On9:hover {
    cursor: default;
    color: #cfced3;
  }

  .Days_Edit__KvVa8 {
    color: #fff;
  }

  .Days_Edit__KvVa8:hover {
    color: #fff;
  }

  .Days_Action__ZxaFq {
    font-size: 1rem;
  }

  .Days_Bold__DmdlL {
    font-weight: 700;
  }

  .Days_Italics__Mtl4n {
    font-style: italic;
  }

  .Days_Div50__bHMHw {
    height: 50px;
    overflow: hidden;
  }

  .Days_Div25__q8tCQ {
    height: 25px;
    overflow: hidden;
  }

  /* @media screen and (max-width: 600px) {
    .Title {
      font-size: .75em;
    }

    .Titledetail {
      font-size: 1.25em;
    }

    .Titlelist {
      font-size: 1.25em;
    }
  } */`, "",{"version":3,"sources":["webpack://./src/styles/Days.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX;mBACiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;;;;;;;;;;;;KAYG","sourcesContent":[".Top {\n  background-color: #1a959c;\n  background-color: #146871;\n  background-color: #208286;\n  background-color: #1a959c;\n  background-color: #1ea7ae;\n  background-color: #0095a3;\n  background-color: #39606e;\n  color: #fff;\n  font-weight: bold;\n}\n\n.Titledetail {\n  color: #000;\n  color: #fff;\n  font-size: .65rem;\n}\n\n.Bottom {\n  background-color: #000;\n  background-color: #353839;\n  background-color: #010b13;\n  color: #fff;\n}\n\n.Bottom:hover {\n  background-color: #0095a3;\n  color: #fff;\n}\n\n.Bottom:hover .Titledetail {\n  color: #fff;\n}\n\n.BreakTitle {\n  border-top: 10px solid #e8f0f1;\n}\n\n.Icon i {\n  color:#fff;\n}\n\n.Icon i:hover {\n  color:#000;\n}\n\n.PostDropdown .DropdownItem i {\n  color: #666;\n}\n\n.SceneLoc {\n  min-height: 130px;\n}\n\n.BottomSB {\n  border-top: 1px solid #00d1ff;\n}\n\n.BottomS {\n  font-style: italic;\n  color: #fff;\n  /* color: #0095a3;\n  color: #00d1ff; */\n}\n\n.Bottom span:hover {\n  background-color: #1a959c;\n  color: #fff;\n}\n\n.SearchBar input {\n    border-radius: 20px;\n    color: #242a3d;\n    padding-left: 40px;\n    margin-bottom: 16px;\n  }\n  \n  .SearchIcon {\n    position: absolute;\n    font-size: 1.2rem;\n    padding: 9px;\n    padding-left: 15px;\n  }\n  \n  .SearchIcon:hover {\n    cursor: default;\n    color: #cfced3;\n  }\n\n  .Edit {\n    color: #fff;\n  }\n\n  .Edit:hover {\n    color: #fff;\n  }\n\n  .Action {\n    font-size: 1rem;\n  }\n\n  .Bold {\n    font-weight: 700;\n  }\n\n  .Italics {\n    font-style: italic;\n  }\n\n  .Div50 {\n    height: 50px;\n    overflow: hidden;\n  }\n\n  .Div25 {\n    height: 25px;\n    overflow: hidden;\n  }\n\n  /* @media screen and (max-width: 600px) {\n    .Title {\n      font-size: .75em;\n    }\n\n    .Titledetail {\n      font-size: 1.25em;\n    }\n\n    .Titlelist {\n      font-size: 1.25em;\n    }\n  } */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Top": `Days_Top__ICOJw`,
	"Titledetail": `Days_Titledetail__U4r0I`,
	"Bottom": `Days_Bottom__7Rwr9`,
	"BreakTitle": `Days_BreakTitle__Fz8aP`,
	"Icon": `Days_Icon__bddJl`,
	"PostDropdown": `Days_PostDropdown__Pktp7`,
	"DropdownItem": `Days_DropdownItem__baHX7`,
	"SceneLoc": `Days_SceneLoc__glnaq`,
	"BottomSB": `Days_BottomSB__-JABI`,
	"BottomS": `Days_BottomS__bSeNJ`,
	"SearchBar": `Days_SearchBar__57zkn`,
	"SearchIcon": `Days_SearchIcon__E6On9`,
	"Edit": `Days_Edit__KvVa8`,
	"Action": `Days_Action__ZxaFq`,
	"Bold": `Days_Bold__DmdlL`,
	"Italics": `Days_Italics__Mtl4n`,
	"Div50": `Days_Div50__bHMHw`,
	"Div25": `Days_Div25__q8tCQ`
};
export default ___CSS_LOADER_EXPORT___;
